const en = {
  copySuccess: 'Copy successful',
  copyError: 'Copy failed, please try again!',
  noRecord: 'No record',
  color: 'Color',
  price: 'Price',
  time: 'Time',
  success: 'Success',
  fail: 'Fail',
  titleText: 'Sky City Club',
  copy: 'Copy address',
  balance: 'Balance',
  buy: 'Purchase',
  loadingText: 'Loading...',
  connectText: `Are you sure you want to install {wallet}?`,
  lastPage: 'No previous page',
  nextPage: 'There is no next page',
  notOpen: 'Not open yet',
  name: 'Cottages',
  notIn: 'Failure to meet sales expectations',
  enter: 'Enter DAPP',
  information: 'Social media',
  loveText: "You've already praised it!",
  skytBal: 'Insufficient SKYT balance !',
  usdtBal: 'Insufficient USDT balance !',
  withdraw: 'Withdrawal',
  Nav: {
    home: 'Home',
    market: 'Market',
    nft: 'My NFT',
    exchange: 'Swap',
    account: 'Account',
    connect: 'Connect Wallet',
    pledge: 'Pledge',
  },
  Account: {
    title: 'My account',
    title2: 'My invitation',
    inviteTitle: 'Invite friends',
    bindSuccess: 'Binding succeeded',
    bindTitle: 'Bind superior',
    copy: 'Copy link',
    bind: 'Bind',
    bindIng: 'Binding...',
    assets: 'Total assets',
    address: 'Please enter the superior address',
    total: 'Transaction revenue',
    income: 'Invitation income',
    parent: 'Superior',
    bindBtn: 'Fill in the address',
    invitePerson: 'Invitees',
    invite: 'Invite',
    record1: 'Revenue log',
    record2: 'My partner',
    code: 'Invitation code: ',
    parentAlert: 'Please bind the superior first!',
    nav: {
      one: 'Income type',
      two: 'Profit',
      three: 'Sell',
      four: 'Extension',
      five: 'Address',
      six: 'Registration time',
      seven: 'Principal',
    },
  },
  Swap: {
    number: 'Please enter the exchange quantity',
    btn: 'Swap',
    type1: `Swap {usdt} USDT for {token} SKYT`,
    type2: `Swap {token} SKYT for {usdt} USDT`,
  },
  AccountTransfer: {
    link: 'View on the BSC browser',
    transfer: 'Recent transactions',
    clear: '(Clear all)',
    account: 'Account',
    record: 'Your transaction will appear here',
  },
  HashType: {
    one: 'Purchase LAND',
    two: 'Sell LAND',
    three: 'Swap USDT for SKYT',
    four: 'Swap SKYT for USDT',
    five: 'Modify LAND',
    six: 'Cancel LAND',
  },
  SwapAlert: {
    title1: 'Swap',
    title2: 'User cancel',
    title3: 'User transaction',
    title4: 'User modification',
    title5: 'User Purchase',
    title6: 'User Sale',
    success1: 'Exchange succeeded',
    success2: 'Cancellation succeeded',
    success3: 'Successful trade',
    success4: 'Modified successfully',
    btn1: 'In exchange',
    btn2: 'Canceling',
    btn3: 'In transaction',
    btn4: 'Modifying',
    close: 'close',
  },
  PixelItem: {},
  EmpowerAlert: {
    one: `Allow market to call your #{tokenId} NFT`,
    two: 'Allow market contracts to call your usdt',
    three: 'Allow NFT contract to call your token',
    four: 'Allow the market contract to call your token',
    btn1: 'In progress',
    btn2: 'Authorized NFT',
    btn3: 'Authorized usdt',
    btn4: 'Authorization token',
    title: 'Authorization',
  },
  Home: {
    title: 'Cast land',
    title1: 'Video',
    title2: 'Cooperative partner',
    text1: 'City of sky',

    text2:
      'The metauniverse of cityinthesky is composed of land. Players who hold land can use it to create and earn income. The number of available lands is always 90000. They can be used to host games, create multiplayer game experiences, build houses, or provide social experiences for the community',
    text3: '20 city of the sky painter',
    text4: 'Select a color',
    text5: '1. Select the pixel to draw',
    text6: 'Welcome',
    text7: 'Sky City Club',
    text8:
      "The ancient empire rabida is a huge machine island floating in the air. It is said that it has been uninhabited and contains great wealth. Therefore, both the military and the pirates are looking for this legendary flying island. Parker, the miner, came across HIDA, the successor of rabida, and the two became friends at first sight. Because HIDA has a flying stone, which is an important object to find the rabida Empire, both the military and the pirates are chasing HIDA. Parker and HIDA fled together, but they didn't escape from the army. HIDA was captured by the army. To save his friend, Parker had to choose to cooperate with the pirates. Parker and the pirates successfully rescued HIDA. At the same time, they also discovered the military's evil plan. In order to prevent the implementation of the military's evil plan, they and the pirates embarked on a journey to find rabida.",

    text9: 'Enter the market',
    text10: 'What is NFT?',
    text11:
      'Non homogenous token (NFT) is a virtual token stored on the blockchain, which has the characteristics of digital scarcity, security and authenticity. They are unique, indivisible, and cannot be interchanged, allowing in-game assets to truly have digital ownership.',
    text12: `User {start}...{end} purchasing NFT`,
    text13:
      'In the virtual meta universe of cityintehsky, players can play, create, own, and use the virtual experience to obtain benefits. You can invest your cryptocurrency to get more gold',
    alert1: 'Please select pixel block first',
    alert2: 'All castings have been completed!',
    btn1: 'Purchase land',
    btn2: 'Immediate pledge',
    likes: 'Likes',
    alert3: 'The casting quantity is full!',
  },
  Market: {
    text: "The ancient empire rabida is a huge machine island floating in the air. It is said that it has been uninhabited and contains great wealth. Therefore, both the military and the pirates are looking for this legendary flying island. Parker, the miner, came across HIDA, the successor of rabida, and the two became friends at first sight. Because HIDA has a flying stone, which is an important object to find the rabida Empire, both the military and the pirates are chasing HIDA. Parker and HIDA fled together, but they didn't escape from the army. HIDA was captured by the army. To save his friend, Parker had to choose to cooperate with the pirates. Parker and the pirates successfully rescued HIDA. At the same time, they also discovered the military's evil plan. In order to prevent the implementation of the military's evil plan, they embarked on a journey to find rabida together with the pirates",
    nav: {
      one: 'Commodity',
      two: 'Floor price',
      three: 'Latest price',
      four: 'Purchaser',
      five: 'Time',
    },
    alert: "You can't buy your own list!",
    seller: 'Owner',
    seeMore: 'Read more',
    down: 'Stow',
    record: 'Records',
    type1: 'Time sorting',
    type2: 'Price sort',
  },
  NFT: {
    tabs: {
      one: 'Holding',
      two: 'On sale',
      three: 'Purchased',
    },
    type1: `User {start}...{end} listing #{tokenId} NFT`,
    type2: `User {start}...{end} canceling listing #{tokenId} NFT`,
    type3: `User {start}...{end} modifying #{tokenId} NFT`,
    changeColor: 'Select the color to replace',
    modity: 'Confirm modification',
    notice: 'The platform will charge an 8% handling fee when selling',
    cancel: 'cancel a sale',
    sell: 'Sell',
    moditySuccess: 'Modified successfully',
    counts: 'total times:',
    notSell: 'Pledgable',
  },
  Propaganda: {
    text1:
      'Each NFT house is unique and programmatically generated from 170 possible features, including roofs, trees, doors and windows, etc.',
    text2:
      'All houses are great, but some are rarer than others. All NFTs are stored on the BSC blockchain and hosted on IPFs.',
  },
};

export default en;
